<script>
  import getTranslation from '../../../utilities/getTranslation';

  export let isMostPopular, hasOfferSpan, subscription, showOffer, offerInfo;

  const withoutProductDescription =
    getTranslation(subscription.informationKeys, 'description.body.v2', '') === '';

  const getGroupPrice = (subscription) => {
    const standardPrice = getTranslation(subscription.informationKeys, 'description.price.v2');
    if (showOffer) {
      return getTranslation(subscription.informationKeys, 'pricing.offer.title', standardPrice);
    }

    return standardPrice;
  };

  const getProductPrice = (product) => {
    const standardPrice = getTranslation(product.informationKeys, 'pricing.title.v2');
    if (showOffer) {
      return getTranslation(product.informationKeys, 'pricing.offer.title', standardPrice);
    }
    return standardPrice;
  };
</script>

<style lang="scss">
  @use './styles/sharedStyles' as *;
  @use '../index' as *;

  .card {
    @include generalCardStyle;
  }

  .price-label {
    color: $black;
    padding: spacing(2);
    margin: 0;
    font-weight: 600;

    &.without-product-description {
      padding-block-start: 0;
    }

    p {
      margin-block-end: 0;

      :global(span) {
        font-size: 2.8rem;
        color: $orange-50;
      }
    }

    @include mq($until: desktop) {
      margin-block-start: -0.6rem;
    }

    $badge-blue: #b9e6ff;

    .badge-wrapper {
      display: flex;
      height: 100%;
      align-items: flex-end;

      .badge {
        width: fit-content;
        height: 2.4rem;
        font-size: 1.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $badge-blue;
        color: $black;
        border-radius: 0.4rem;
        padding-inline: 1.6rem;
        margin-block-start: 1.6rem;

        > p {
          margin-block-end: 0;
        }
      }
    }
  }
</style>

<div
  class="card price-label"
  class:most-popular-border={isMostPopular}
  class:without-product-description={withoutProductDescription}
>
  <p>
    {#if subscription.products.length > 1}
      {@html getGroupPrice(subscription)}
      <!-- this is to add an empty span to the price if there is an offer to keep all prices aligned -->
      {#if hasOfferSpan} <span>&nbsp;</span> {/if}
    {:else}
      {#each subscription.products as product}
        {@html getProductPrice(product)}
        <!-- this is to add an empty span to the price if there is an offer to keep all prices aligned -->
        {#if hasOfferSpan} <span>&nbsp;</span> {/if}
      {/each}
    {/if}
  </p>
  {#if showOffer && offerInfo.description}
    <div class="badge-wrapper">
      <div class="badge">
        <p>
          {offerInfo.description.toUpperCase()}
        </p>
      </div>
    </div>
  {/if}
</div>
